import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Radio } from '../Radio/Radio';
import { Topography } from '../Topography/Topography';

import masterCard from 'assets/images/master-card.png';
import visa from 'assets/images/visa.png';
import discover from 'assets/images/discover.png';
import amex from 'assets/images/amex.png';

import styles from './PaymentItem.module.scss';

type BasePaymentProps = {
  className?: string;
};

type ItemProps = BasePaymentProps & {
  onSelect: (value: string, cardNumber: string, cardType: string, billingName: string) => void;
  isSelected: boolean;
  radioValue: string;
  radioName: string;
  cardOwner?: string;
  cardNumber: string;
  cardType: string;
  billingName: string;
};

export const Item: React.FC<ItemProps> = ({
  className,
  isSelected,
  radioValue,
  radioName,
  cardOwner,
  cardNumber,
  cardType,
  billingName,
  onSelect,
}) => {
  function cardTypeImg() {
    switch (cardType) {
      case 'masterCard':
        return masterCard;
      case 'discover':
        return discover;
      case 'visa':
        return visa;
      case 'amex':
        return amex;
      default:
        return masterCard;
    }
  }

  return (
    <div
      className={clsx(styles.root, styles.item, className)+' crad_wrapper'}
      onClick={onSelect.bind(null, radioValue, cardNumber, cardType, billingName)}
      id={`Card_${cardNumber}`}
    >
      <div className={styles.body}>
        <img className={styles['master-card']} src={cardTypeImg()} alt={cardType} />
        <Topography.H4 className={styles.owner}>{cardOwner}</Topography.H4>
        <div className={styles.number}>{`**** **** **** ${cardNumber}`}</div>
        <Radio name={radioName} value={radioValue} checked={isSelected} className={styles.radio} />
      </div>
    </div>
  );
};

type NewProps = BasePaymentProps & {
  to?: string;
  onClick?: () => void;
};

export const New: React.FC<NewProps> = ({ className, to, onClick }) => (
  <div className={clsx(styles.root, styles.new, className)}>
    {to && (
      <Link to={to} className={styles.body}>
        <Topography.H4>ADD CARD</Topography.H4>
      </Link>
    )}
    {onClick && (
      <div onClick={onClick} className={styles.body}>
        <Topography.H4>ADD CARD</Topography.H4>
      </div>
    )}
  </div>
);

export const Payment = {
  Item,
  New,
};
